export const commonAttachMixin = {
  data() {
    return {
      attachList: [],
      attachAcceptType: '.xls,.xlsx,.doc,.docx,.pdf,.jpg,.jpeg,.png,.bmp,.txt',
    }
  },
  watch: {
    attachList(n) {
      this.form.attachIds = n.map(attach => attach.id);
    }
  },
  methods: {
    attachHandleError(err, file) {
      this.$message.error(`${file.name} 附件上传发生错误：${err}，请重新上传`)
    },
    attachHandleSuccess(resp, file, fileList) {
      if (resp.status !== 200) {
        let err = '未知错误';
        if (resp.msg) err = resp.msg;
        this.$message.error(`${file.name} 附件上传发生异常：${err}，请手动删掉已上传的附件并重新上传`);
        return
      }
      if (resp.obj && resp.obj.id) {
        file.id = resp.obj.id;
        this.attachList = fileList;
      }
    },
    attachHandleRemove(file, fileList) {
      this.attachList = fileList;
    },
    attachHandlePreview(file) {
      window.open(`/sysAttach/downLoadAttach?attachId=${file.id}`)
    },
    attachBeforeUpload(file) {
      let fileSuffix = file.name.substring(file.name.lastIndexOf("."), file.name.length);
      if (this.attachAcceptType.indexOf(fileSuffix) === -1) {
        this.$message.warning(`不支持${fileSuffix}类型的附件`);
        return false
      }
    },
    attachBeforeRemove(file) {
      if (file.status !== 'success') return;
      return this.$confirm(`确定移除 ${file.name}？`, '提示', {type: 'warning'}).then(_ => {
        if (file.id && file.state && file.state === 1) {
          this.postRequest('/sysAttach/delete', {'attachId': file.id});
        }
      })
    },
    attachHandleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 5 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`)
    },
    handleClose() {
      this.attachList = [];
      this.$refs.form.clearValidate();
      this.$emit('update:formVisible', false)
    }
  }
};
